import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4295882c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header__controls icon-toolbar" }

import { onBeforeMount, onBeforeUnmount, ref } from 'vue'

import BackLink from '@/app/components/BackLink.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import ExportBookButton from '@/app/components/doc/preview/ExportBookButton.vue'
import { emitter } from '@/services/mitt'
import { DocView } from '@/models/doc'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderPreviewPage',
  props: {
    doc: null
  },
  setup(__props: any) {



const isRounded = ref(false)

onBeforeMount(() => {
  emitter.on('appScroll', scrollHandler)
})

onBeforeUnmount(() => {
  emitter.off('appScroll')
})

function scrollHandler(): void {
  // Get current scrolling position
  const scrollTop = (document.getElementById('app') as HTMLElement).scrollTop

  // Get height of the book block - it's different on different widths
  const bookBlockHeight = (
    document.querySelector('.doc-preview__cover') as HTMLElement
  ).offsetHeight

  // Book block has roundings, and we need to apply rounding to the header
  // before it reaches the roundings of the book block.
  const maxScroll = bookBlockHeight - 8
  isRounded.value = scrollTop > maxScroll
}

return (_ctx: any,_cache: any) => {
  return (__props.doc)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["header header--book header--book-preview", { 'header--book-preview-rounded': isRounded.value }])
      }, [
        _createVNode(BackLink, { class: "header__backlink" }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(DocListsMenu, {
            class: "book-preview-favorite-btn icon-toolbar__item icon-toolbar__item--separator",
            doc: __props.doc,
            positon: "center"
          }, null, 8, ["doc"]),
          (__props.doc.showDownload)
            ? (_openBlock(), _createBlock(ExportBookButton, {
                key: 0,
                class: "book-preview-download-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          _createVNode(DocLibraryMenu, {
            class: "book-preview-actions-btn icon-toolbar__item icon-toolbar__item--separator",
            doc: __props.doc,
            position: "right"
          }, null, 8, ["doc"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})